import { onMount } from "svelte";
import { useEventDispatcher } from "./event-dispatcher.js";

/**
 *
 *
 *
 *
 *
 */
export const useMountEvents = (component: string, element: HTMLElement): void => {
  const dispatch = useEventDispatcher(element);

  onMount(() => {
    dispatch(
      `${component}-mount`,
      { component, element },
      { cancelable: false, alias: ["oc-mount"] },
    );
    return () => {
      dispatch(
        `${component}-unmount`,
        { component, element },
        { cancelable: false, alias: ["oc-unmount"] },
      );
    };
  });
};
